import React, { useEffect } from 'react';

interface IProps {
  url: string;
}

export function JotForm({ url }: IProps) {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = `https://eu.jotform.com/jsform/${url}?appendTo=jotform`;
    document.getElementById('jotform')?.appendChild(script);
  }, [url]);
  return <div id="jotform"></div>;
}
